/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendFreshnessResponseDto } from '../../models/backend-freshness-response-dto';

export interface GetFreshnessFreshnessGet$Params {}

export function getFreshnessFreshnessGet(
  http: HttpClient,
  rootUrl: string,
  params?: GetFreshnessFreshnessGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendFreshnessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getFreshnessFreshnessGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendFreshnessResponseDto>;
    }),
  );
}

getFreshnessFreshnessGet.PATH = '/freshness';
